import React from 'react';

import { runningInRNWebView } from '@eika-infrastruktur/mobilbank-lib';
import { QueryResult } from '@eika-infrastruktur/react-query';
import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';
import { AlertAnimation } from '@eika/alert-animation';
import { LinkButton, StandardButton } from '@eika/button';
import { ErrorCard, InfoCard } from '@eika/card';
import { DetailsList, DetailsListItem } from '@eika/details-list';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import type { ContactInfo } from '../../generated-types';
import useTranslation from '../../hooks/useTranslation';
import { cleanupEmail, getPhoneNumberJSX } from '../ContactInformation/format';

type Props = {
    ifSuccess: boolean;
    error?: RequestExceptionWithResponse;
    contactInfo: QueryResult<ContactInfo>;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const PeriodicControlModalBody: React.FC<Props> = ({ ifSuccess, error, contactInfo, setOpen }) => {
    const translation = useTranslation();

    if (ifSuccess) {
        return (
            <InfoCard
                className="thanks-for-update"
                img={<RichIcon type={RichIconTypes.HJERTE_GLINSER} />}
                skipBackground
            >
                <InfoCard.TitleH3>{translation.periodicControl.thanks}</InfoCard.TitleH3>
                <p className="typography-paragraph">{translation.periodicControl.howToEdit}</p>
                <StandardButton onClick={() => setOpen(false)} className="button-back-to-mobilbank" size="small">
                    {runningInRNWebView
                        ? translation.periodicControl.backToMobileBank
                        : translation.periodicControl.backToNettbank}
                </StandardButton>
            </InfoCard>
        );
    }

    if (error) {
        return (
            <ErrorCard
                isModal
                title={translation.periodicControl.errorTitle}
                description={translation.periodicControl.error}
                icon={<AlertAnimation />}
            >
                <div className="periodic-control__footer">
                    <LinkButton onClick={() => setOpen(false)}> {translation.periodicControl.cancel}</LinkButton>
                </div>
            </ErrorCard>
        );
    }

    return (
        <>
            <InfoCard
                img={<RichIcon type={RichIconTypes.KONTAKTINFO} />}
                skipBackground
                className="periodic-control-contact-infobox"
            >
                <InfoCard.TitleH3>{translation.periodicControl.correctContactInfo}</InfoCard.TitleH3>
                <p className="typography-paragraph">{translation.periodicControl.intro}</p>
            </InfoCard>
            <DetailsList>
                <DetailsListItem
                    label={translation.contactInfo.mobile}
                    value={contactInfo.data?.phoneNumber}
                    formatter={getPhoneNumberJSX}
                />
                <DetailsListItem
                    label={translation.contactInfo.email}
                    value={contactInfo.data?.email}
                    formatter={cleanupEmail}
                />
            </DetailsList>
        </>
    );
};

export default PeriodicControlModalBody;
